<template>
  <div class="news-main-content">
    <div class="main-content">
      <div class="news-center-top">
        <div class="left-content">
          <h3>资讯中心</h3>
          <p>了解峰学未来整理的最新高报资讯动态</p>
        </div>
        <div class="right-content">
          <router-link target="_blank" to="/news">
            <el-button>查看更多</el-button>
          </router-link>
        </div>
      </div>
      <div class="news-center-bottom">
        <div class="left-content">
          <router-link :to="{ name: 'newsdetails', params: { id: newsLeft.uuid } }">
            <div class="img_div"><img :src="newsLeft.cover_url" class="image" /></div>
            <h3>{{ newsLeft.title }}</h3>
          </router-link>
        </div>
        <div class="right-content">
          <ul>
            <li v-for="item in newsRight" :key="item.uuid" class="news-right-content">
              <router-link :to="{ name: 'newsdetails', params: { id: item.uuid } }">
                <div class="img_div">
                  <img :src="item.cover_url" class="image" />
                </div>
                <div class="summary">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.summary }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsCenter",
  data() {
    return {
      newsLeft: {},
      activeName: 'recent',
      page: 1,
      size: 12,
      newstype: 1,
      newsRight: [],
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http({
        method: 'get',
        url: '/api/v1/main_station/main/news/',
        params: {
          mold: this.newstype,
          title: '',
          page: this.page,
          size: this.size
        },
        headers: {
          'AUTH-SYS': 'admin'
        },
      }).then(res => {
        this.newsLeft = res.data.data.results[0];
        const news1 = res.data.data.results[1];
        const news2 = res.data.data.results[2];
        const news3 = res.data.data.results[3];
        this.newsRight.push(news1)
        this.newsRight.push(news2)
        this.newsRight.push(news3)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}

@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}

.news-main-content {
  width: 100%;
  background: #FFFFFF;
  margin: 0 auto;
  padding: 120px 0;

  a {
    text-decoration: none;
  }

  .main-content {
    width: 1200px;
    margin: 0 auto;

    .news-center-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left-content {
        width: 70%;

        h3 {
          font-size: 40px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
          font-weight: bold;
          color: #0A0D0F;
          line-height: 60px;
          letter-spacing: 2px;
        }

        p {
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #909295;
          line-height: 30px;
          letter-spacing: 2px;
          margin-top: 20px;
          text-align: justify;
        }
      }

      .right-content {
        align-self: flex-end;

        button {
          width: 140px;
          height: 52px;
          border-radius: 8px;
          border: 1px solid rgba(219, 221, 224, 1);
          font-size: 18px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #909295;
        }

        .el-button:hover {
          background-color: #0086FF;
          color: #ffffff;
          border: none;
        }

        .el-button:focus {
          background-color: transparent;
          color: #909295;
        }
      }
    }

    .news-center-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 60px;

      .left-content {
        width: 545px;
        height: 440px;
        border-right: 1px solid rgba(219, 221, 224, 0.5);
        padding-right: 30px;
        transition: all .8s;

        .img_div {
          width: 545px;
          height: 332px;
          overflow: hidden;
          border-radius: 12px;
        }

        img {
          width: 545px;
          height: 332px;
          border-radius: 12px;
          transition: all .8s;
        }

        img:hover {
          transform: scale(1.05);
        }

        h3 {
          font-size: 30px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 45px;
          margin-top: 24px;
          height: 90px;
        }
      }

      .left-content:hover {
        img {
          transform: scale(1.05);
        }

        h3 {
          color: #0086FF;
        }
      }

      .right-content {
        width: 625px;
        height: 440px;
        padding-left: 30px;

        ul {
          li {
            list-style-type: none;

            a {
              display: flex;
              /*align-items: center;*/
              justify-content: space-between;
              border-bottom: 1px solid rgba(219, 221, 224, 0.5);
              transition: all .3s;

              .img_div {
                width: 193px;
                /*height: 118px;*/
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 20px;
              }

              img {
                width: 193px;
                height: 118px;
                border-radius: 8px;
                margin-top: 20px;
                transition: all .8s;
              }

              img:hover {
                transform: scale(1.05);
              }

              .summary {
                padding-left: 16px;

                h4 {
                  font-size: 22px;
                  font-family: 'SourceHanSansCNBold Microsoft YaHei';
                  font-weight: bold;
                  color: #0A0D0F;
                  line-height: 33px;
                  width: 386px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  padding-top: 35px;
                }

                p {
                  font-size: 18px;
                  font-family: 'SourceHanSansCN Microsoft YaHei';
                  font-weight: 400;
                  color: #434649;
                  line-height: 27px;
                  padding-top: 20px;
                  width: 386px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
              }
            }

            a:hover {
              .img_div {
                width: 193px;
                /*height: 118px;*/
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 20px;
              }

              img {
                transform: scale(1.05);
              }

              .summary {
                h4 {
                  color: #0086FF;
                }
              }
            }
          }

          li:nth-child(1) {
            .img_div {
              width: 193px;
              /*height: 118px;*/
              border-radius: 8px;
              overflow: hidden;
              margin-bottom: 20px;
            }

            img {
              margin-top: 0;
            }

            .summary {
              h4 {
                padding-top: 15px;
              }
            }
          }

          li:nth-child(3) {

            /*border-bottom: 0;*/
            .img_div {
              width: 193px;
              /*height: 118px;*/
              border-radius: 8px;
              overflow: hidden;
              margin-bottom: 20px;
            }

            img {
              margin-bottom: 0;
            }

            a {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>